import { useContext, useEffect, useRef, useState } from 'react'
import { Alert, Box, CircularProgress, Typography } from '@mui/material'
import cookie from 'react-cookies'

import { AppContext } from '/providers/app-context'
import { redeemSupportLogin } from '/providers/auth-api'

export default function SupportLogin() {
  const { apiSource, setApiSource } = useContext(AppContext)
  const startedRef = useRef(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (startedRef.current) return
    startedRef.current = true

    const linkParameters = new URLSearchParams(window.location.hash.slice(1))
    const token = linkParameters.get('token')
    const linkApiSource = linkParameters.get('source')
    const selectedApiSource = ['local', 'remote'].includes(linkApiSource) ? linkApiSource : apiSource
    window.history.replaceState({}, '', '/support-login')

    if (!token) {
      setError('This support login link is invalid or has expired.')
      return
    }

    setApiSource(selectedApiSource)
    cookie.save('apiSource', selectedApiSource, { path: '/' })

    redeemSupportLogin({ apiSource: selectedApiSource, token }).then(result => {
      if (!result?.authenticated) {
        setError(result?.error?.message ?? result?.error ?? 'This support login link is invalid or has expired.')
        return
      }

      window.location.replace('/templates')
    })
  }, [apiSource, setApiSource])

  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 3 }}>
      <Box sx={{ width: '100%', maxWidth: 520, textAlign: 'center' }}>
        {error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <>
            <CircularProgress size={32} />
            <Typography sx={{ mt: 2 }}>Opening Smartix Studio support session...</Typography>
          </>
        )}
      </Box>
    </Box>
  )
}
